import React from "react";

export default class NoResult extends React.Component {
    render() {
        return (
            <>
                <h1>404</h1>
                <h2>Page Not Found</h2>
            </>
        );
    }
}